import { CampaignParameters } from '@travelwin/core';
import Cookies from 'js-cookie';

export const UtmParametersKey = 'utmParameters';

/**
 * Following functionality needs to span across eCommerce app but also external CMS.
 * That's why most of the following code is duplicated in packages/ecommerce/public/session.html.
 *
 * This file is use in external CMS inside an iframe, and it synchronises the user session between it and react app.
 *
 * As we don't have any automatic process to synchronise them, <strong>always synchronise changes in both files!</strong>
 */
export const setupCampaignParamsCookieExpiryExtensionListeners = (
  userSessionTimeout: number,
): (() => void) => {
  const listener = () => sessionExtendHandler(userSessionTimeout);

  if (getCampaignParametersFromStorage()) {
    document.addEventListener('click', listener);
    document.addEventListener('keydown', listener);
  }

  return () => {
    document.removeEventListener('click', listener);
    document.removeEventListener('keydown', listener);
  };
};

export const storeCampaignParametersFromUrl = (userSessionTimeout?: number) => {
  const parameters = getCampaignParametersFromUrl();
  if (!isObjectEmpty(parameters)) {
    storeCampaignParameters(parameters, userSessionTimeout || 30);
  }
};

export const getCampaignParametersFromStorage =
  (): CampaignParameters | null => {
    const params = JSON.parse(Cookies.get(UtmParametersKey) || '{}');

    if (params) {
      if (!isObjectEmpty(params)) {
        return params;
      }
    }
    return null;
  };

export const storeCampaignParameters = (
  params: CampaignParameters,
  userSessionTimeout: number,
) => {
  const date = new Date();
  date.setTime(date.getTime() + userSessionTimeout * 60 * 1000);

  document.cookie = serializeCampaignParameters(
    params,
    window.location.hostname,
    userSessionTimeout,
  );
};

export const serializeCampaignParameters = (
  params: CampaignParameters,
  hostname: string,
  userSessionTimeout: number,
) => {
  const date = new Date();
  date.setTime(date.getTime() + userSessionTimeout * 60 * 1000);

  return `${UtmParametersKey}=${JSON.stringify(
    params,
  )}; domain=${hostname}; expires=${date.toUTCString()}; sameSite=strict; path=/;`;
};

const sessionExtendHandler = (userSessionTimeout: number) => {
  const params = getCampaignParametersFromStorage();
  if (params) {
    storeCampaignParameters(params, userSessionTimeout);
  }
};

export const getCampaignParametersFromUrl = (
  url?: string,
): CampaignParameters => {
  const { searchParams } = new URL(url ?? window.location.href);
  return {
    utm_source:
      searchParams.get('unite_source') || searchParams.get('utm_source'),
    utm_medium:
      searchParams.get('unite_medium') || searchParams.get('utm_medium'),
    utm_campaign:
      searchParams.get('unite_campaign') ||
      searchParams.get('utm_campaign') ||
      searchParams.get('sv_campaign_id'),
    utm_term: searchParams.get('unite_term') || searchParams.get('utm_term'),
    utm_content:
      searchParams.get('unite_content') || searchParams.get('utm_content'),
    awin_awc: searchParams.get('awc'),
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObjectEmpty = (object: any) => {
  for (const key in object) {
    if (object[key] !== null && object[key] !== undefined) {
      return false;
    }
  }
  return true;
};
